import { render, staticRenderFns } from "./ProviderApproval.vue?vue&type=template&id=5c7fc363&scoped=true&"
import script from "./ProviderApproval.vue?vue&type=script&lang=js&"
export * from "./ProviderApproval.vue?vue&type=script&lang=js&"
import style0 from "./ProviderApproval.vue?vue&type=style&index=0&id=5c7fc363&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7fc363",
  null
  
)

export default component.exports